type Props = {
    name?: string;
    url?: string | null;
};

const ProductName = ({ name, url }: Props) => {
    if (url && name) {
        return <a href={url}>{name}</a>;
    } else {
        return <span>{name}</span>;
    }
};

export { ProductName };
